const imageContainerWidth = (id) => {
  const currentNode = document.querySelector(`[data-selectable-id="${id}"]`)
  if (currentNode) return currentNode.clientWidth;
}
export default imageContainerWidth;
